import { merge } from 'lodash';

/**
 * Safely enriches a given set of events with a given enrichment.
 * @param {Object[]} events - The events to be enriched.
 * @param {Object} enrichment - The enrichment to be set upon each event.
 * @return {Object[]}
 */
export const enrichEvents = (events, enrichment = {}) => {
    if (!events) {
        return events;
    }

    if (!Array.isArray(events)) {
        return events;
    }

    if (events.find((event) => typeof event !== 'object')) {
        return events;
    }

    return events.map((event) => merge(
        {},
        enrichment,
        event
    ));
};
